import React,{useState,useEffect} from 'react';
//import emailjs from '@emailjs/browser';
import {Link} from 'react-router-dom';
import Collapse from 'react-bootstrap/Collapse';
import {GetSiteSubjectSubSubject,WebGetFooterDetails} from "./../components/APISCollection";
//images
import whatsapp from "./../assets/images/Resources/whatsapp.png";
import logo from './../assets/images/logo_bvs.jpg';


const currentYear = new Date().getFullYear();
function heartToggle(){
 	var  heartBlaste = document.querySelector('.heart');
 	if(heartBlaste){
		heartBlaste.classList.toggle("heart-blast");			
 	}	
}

//function slideDown(el) {
//	console.log(el);
//	const elem = document.getElementById(el);
//	console.log(elem);
//	document.getElementById("myH1").style.color = "red";
//	elem.style.transition = "all 2s ease-in-out";
//	//elem.style.height = "400px";
//}

// const accordList = [
// 	{name:'Architecture'},{name:'Art'},{name:'Action'},{name:'Biography'},
// 	{name:'Body, Mind & Spirit'},{name:'Business & Economics'},
// 	{name:'Children Fiction'},{name:'Children Non-Fiction'},
// 	{name:'Comics & Graphics'},{name:'Cooking'},
// 	{name:'Crafts & Hobbies'},{name:'Design'},
// 	{name:'Drama'},{name:'Education'},
// 	{name:'Family & Relationships'},{name:'Fiction'},
// 	{name:'Foreign Language'},{name:'Games'},
// 	{name:'Gardening'},{name:'Health & Fitness'},
// 	{name:'History'},{name:'House & Home'},
// 	{name:'Humor'},{name:'Literary Collections'},
// 	{name:'Mathematics'},{name:'Medical'},
// 	{name:'Nature'},{name:'Performing Arts'},
// 	{name:'Pets'},{name:'Show others'}
// ];





function Footer({footerChange, logoImage}){
	//const [open, setOpen] = useState(false);
	const [accordBtn, setAccordBtn] = useState();
	const [accordList,setaccordList] = useState([]);	
	const [FooterList,setFooterList] = useState([]);	
	var TopicID = 0, action = 1;
	//let subscribe = true; 
	useEffect(()=>{   
		var subjectID = "";
		GetSiteSubjectSubSubject(subjectID).then(result=>{ 
				setaccordList(result.data);
		}).catch(error => { console.log(error); });  
			
		WebGetFooterDetails(TopicID,action).then(result=>{ 
			setFooterList(result.data);
		}).catch(error => { console.log(error); }); 

	 },[]);



	return(
		<>
			<footer className={`site-footer`}>				
				<div className="footer-category">
					<div className="container">
						{/* <div className="category-toggle"> <Link to={"#"} className={`toggle-btn ${accordBtn ? 'active' : ''}`} onClick={() => setAccordBtn(!accordBtn)} >Browse All Subjects</Link>
							<div className="toggle-items row">
								<Collapse in={accordBtn} className="footer-col-book">
									<ul>
										{accordList.map((data, ind)=>(
											<li key={data.SubjectId}>
												<a  target="_parent" href={"book-shop-search?q="+data.SubjectName} >{data.SubjectName}</a>
												
											</li>
										))}
									</ul>
								</Collapse>
							</div>
						</div> */}
					</div>
				</div>				
				<div className="footer-top">
					<div className="container">
						<div className="row">
							<div className="col-xl-4 col-lg-12 wow fadeInUp" data-wow-delay="0.1s">
								<div className="widget widget_about">
									<div className="footer-logo logo-white">
										<Link to={"/"}><img src={logo} alt="Education World" /></Link> 
									</div>
									<p className="text fontFootertext">राष्ट्रीय विचारांचा प्रचार आणि प्रसार या उद्देशाने शके १८९८ , सन १९७६ मध्ये संस्थेची स्थापना करण्यात आली. बालसाहित्य , संस्कारक्षम पुस्तके, सामाजिक ,राष्ट्रीय, विज्ञान ,शेती, पर्यावरण , योग, आरोग्य संतसाहित्य , अर्थकारण , समरसता , चारित्र्ये, कुटुंब प्रबोधन इत्यादी विषयावरील  ग्रंथ, पुस्तके आणि पुस्तिका आशी सुमारे  ६५० प्रकाशने आजवर प्रकाशित केली आहेत. संस्कृत, मराठी, हिंदी व इंग्रजी या भाषे मधून विविध पुस्तके प्रकाशित केली आहेत.									 
										<br/>
										<Link className="footertext"  to={"/about-us"}>Read More.</Link> 
									</p>
									<div className="dz-social-icon style-1">
										<ul>
											<li><a href="https://www.facebook.com/BharatiyaVicharSadhana" target="_blank" rel="noreferrer"><i className="fa-brands fa-facebook-f"></i></a></li>
											{/* <li><a href="https://www.youtube.com/channel/UCGL8V6uxNNMRrk3oZfVct1g" target="_blank" rel="noreferrer"><i className="fa-brands fa-youtube"></i></a></li> */}
											<li><a href="#" target="_blank" rel="noreferrer"><i className="fa-brands fa-linkedin"></i></a></li>
											<li><a href="#" target="_blank" rel="noreferrer"><i className="fa-brands fa-instagram"></i></a></li>
										</ul>
									</div>
								</div>
							</div>
							<div className="col-xl-4 col-lg-3 col-md-4 col-sm-4 col-12 wow fadeInUp" data-wow-delay="0.2s">
								<div className="widget widget_services">
									<h5 className="footer-title fontFooterte">Important Links</h5>
									<ul>
									{FooterList.map((data, ind)=>(
											<li key={data.TopicID}>
												<a className="footertext fontFootertext"  href={"company-info?id="+data.TopicID} target="_parent">{data.Name}</a>
											</li>											
										))} 
										<li >
											<a className="footertext fontFootertext"  href={"career"} target="_parent">Career</a>
										</li>
									</ul>
								</div>
							</div> 
							<div className="col-xl-4 col-lg-3 col-md-4 col-sm-4 col-4 wow fadeInUp" data-wow-delay="0.4s"  style={{display:"none"}}>
								<div className="widget widget_services">
									<h5 className="footer-title"></h5>
									<ul style={{display:"none"}}>
										<li><Link to={"services"}>Download</Link></li>
										<li><Link to={"help-desk"}>Help Center</Link></li>
										<li><Link to={"shop-cart"}>Shop Cart</Link></li>
										<li><Link to={"shop-login"}>Login</Link></li>
										<li><Link to={"about-us"}>Partner</Link></li>
									</ul>
								</div>
							</div>
							<div className="col-xl-4 col-lg-3 col-md-12 col-sm-12 wow fadeInUp" data-wow-delay="0.5s">
								<div className="widget widget_getintuch">
									<h5 className="footer-title fontFooterte fontFootertexthead">Get in Touch With Us</h5>
									<ul>
										<li>
											<a className="footertext fontFootertext" href="https://goo.gl/maps/Gw3N59TcAZKkfKP29" target="_blank">
												<i className="flaticon-placeholder"></i>
												<span>309 Motibaug, Shaniwar Peth, Opp to Ahillyadevi Highschool,Pune. 411030</span>
											</a> 
										</li>
										<li>
											<a  className="footertext fontFootertext" href="tel:020.27151988" target="_blank">
												<i className="flaticon-phone"></i>
												<span>+91-02027151988</span>
											</a> 
										</li>
										<li>
											<a  className="footertext fontFootertext" href="tel:+91 8799931616" target="_blank">
												<i className="flaticon-phone"></i>
												<span>+91-8799931616</span>
											</a> 
										</li>
										<li>
											<a  className="footertext fontFootertext" href="mailto:bhavisapune@gmail.com" target="_blank">
												<i className="flaticon-email"></i> 
													<span>sales@bvsf.in</span>
											</a> 
										</li>
										<li>
										<a  className="footertext fontFootertext" href="https://api.whatsapp.com/send?phone=918799931616&amp;text='Hello! I would like to know more about your Services and Offers'" target="_blank">
											<i className="fa fa-whatsapp whatsAPPicon" style={{backgroundImage: 'url('+ whatsapp +')'}}></i>
												<span>WhatsApp Us</span>
											</a> 
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="footer-bottom">
					<div className="container">
						<div className="row fb-inner">
							<div className="col-lg-6 col-md-12 text-start"> 
								<p className="copyright-text fontFootertext">Copyright {currentYear} Bhavisa. All Right Reserved.</p>
							</div>
							<div className="col-lg-6 col-md-12 text-end"> 
								<p>Made with <span className="heart" onClick={heartToggle} ></span> by 
								<a href="https://springtimesoftware.net/" className="footertext fontFootertext"  target="_blank"> Spring Time Software Solutions Pvt. Ltd.</a></p>
							</div>
						</div>
					</div>
				</div>
			</footer>			
		</>
	)
}
export default Footer;